var React = require('react');

function IcWinnerComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-winner"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M17.048 7.6772L15.6909 6.34387L15.6909 6.34389L17.048 7.6772ZM7.25279 14.1398L4.20996 9.20108L8.42977 2.35815H16.9044L21.1242 9.20108L18.0814 14.1398V21.6419L12.6671 19.8372L7.25279 21.6419V14.1398ZM8.55755 16.0439V19.8307L12.6671 18.4694L16.7766 19.8307V16.0439H8.55755ZM16.1676 3.66292H9.1665L5.74295 9.20101L9.1665 14.7391H16.1676L19.5912 9.20101L16.1676 3.66292ZM11.6677 10.8164L9.64326 8.79194L8.71113 9.72407L11.6659 12.658L16.6224 7.67956L15.6934 6.76688L11.6677 10.8164Z","fill":"#006736"})));
}

IcWinnerComponent.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = IcWinnerComponent;

IcWinnerComponent.default = IcWinnerComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/CompareModalV2/images/ic-winner.component.svg
// module id = 689
// module chunks = 0